<template>
  <el-dialog :title="dialogTitle" :visible.sync="addDialogVisible" width='800px'
             @close="dialogClose" center top="10vh">
  <div class="list-add">
    <!-- 添加弹框 -->
    <div class="add">
      <div class="baseInfo">
        <div class="baseInfoContent">
          <el-form :model="modifyData" label-width="120px" label-position="right" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <div-border label="基础信息" prop="plan" >
              <el-form-item label="运输方式：" prop="transportType" style="margin-top: 15px">
                <el-radio-group v-model="modifyData.transportType" @input="handleInput">
                  <el-radio :label=1>公路</el-radio>
                  <el-radio :label=2>水路</el-radio>
                  <el-radio :label="3">联运</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="费用类型：" prop="priceType">
                    <el-select v-model="modifyData.priceType" style="width: 100%" filterable placeholder="请选择费用类型" size="mini" value-key="typeId">
                      <el-option v-for="item in priceTypeOption" :label="item.classaName" :value="item.classbName" :key="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="路线：">
                    <el-input style="width: 40%" v-model="modifyData.startAddressName" placeholder="起始地：省份或港口" autocomplete="off" size="mini" />
                    <span style="margin: 0 20px;">-</span>
                    <el-input style="width: 40%" v-model="modifyData.endAddressName" placeholder="目的地：省份或港口" autocomplete="off" size="mini" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="委托商：" prop="customerName">
                    <el-select v-model="modifyData.customerName" style="width: 100%" filterable size="small" value-key="id" placeholder="请选择委托商">
                      <el-option v-for='item in consignorOption' :key='item.id' :label='item.customer_name'
                                 :value='item' ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div-border>
            <div style="padding: 15px 0" class="basicsStyle">
              <div-border label="价格设置" style="padding: 29px 20px">
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="品牌：" prop="brandName">
                      <el-select v-model="modifyData.brandName" size="mini" style="width: 100%" filterable placeholder="请选择品牌" multiple>
                        <el-option v-for="item in brandNameOption" :key="item.id" :label="item.brand" :value="item.brand" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="单价：" prop="price">
                      <el-input size="small" v-model="modifyData.price" placeholder="请输入单价" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="开始时间：" prop="startDate">
                      <el-date-picker v-model="modifyData.startDate" style="width: 100%" size="small" type="datetime" placeholder="选择开始时间" value-format="yyyy-MM-dd HH:mm:ss" @change="validityTimeChange"> </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="结束时间:" prop="endDate">
                      <el-date-picker v-model="modifyData.endDate" style="width: 100%" size="small" type="datetime" placeholder="选择结束时间" value-format="yyyy-MM-dd HH:mm:ss" @change="timeChange" default-time="23:59:59"> </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="备注：">
                      <el-input style="width: 510px" v-model="modifyData.remake" placeholder="请输入备注"  autocomplete="off" type="textarea" size="mini" />
                    </el-form-item>
                  </el-col>
                </el-row>
              </div-border>
            </div>
          </el-form>
        </div>
        <div class="btnContainer">
          <el-button class="searchBtn" size="medium" :loading="loading" @click="addClick">确认
          </el-button>
          <el-button class="resetBtn" size="medium" @click="dialogClose">关闭</el-button>
        </div>
      </div>
    </div>
  </div>
  </el-dialog>
</template>

<script>
import { baseImgUrl, baseUrl } from '@/config/env';
import uploadImg from '@/components/uploadImg';
import divBorder from '@/components/divBorder';
import cascader from '@/components/cascader';
import {getModelList, publicSelectLine, yearMonthPlanHighwayBrandList} from '@/service/vehiclelog';
import {
  contractPageList,
  customerInfoSelectList,
  getCarSerieList,
  lineAddConsignorLine,
  lineUpdateConsignorLine,
  planConsignorAdd, planConsignorUpdate
} from '@/service/financial';
import { formatDateTime, getSessionStore } from '@/config/mUtils';
import PDFPreview from '@/components/PDFPreview';
import {feeId} from "@/service/contract";
import {paramCategoryPageList} from "@/service/basicfile";

export default {
  components: {
    uploadImg,
    divBorder,
    cascader,
    PDFPreview,
  },
  data() {
    return {
      dialogTitle: '',
      addDialogVisible: false,
      modifyData: {
        transportType: '', //运输方式
        customerName: '', // 委托商
        startDate: '', // 有效期始
        endDate: '', // 结束时间
        startAddressName: '', // 起始地
        endAddressName: '', // 目的地
        brandName: '', // 品牌
        priceType: '',
        price: '',
        remake: ''
      },
      brandNameOption: [],
      priceTypeOption:[],
      companyListfee: [],
      //总数据条数
      total: 0,
      //当前页数
      page: 1,
      //每页显示多少条数据
      rows: 10,
      consignorOption: [],
      loading: false,
      tableLoad: false,
      rules: {
        transportType: {
          required: true,
          message: '请选择运输方式',
          trigger: 'blur',
        },
        price: {
          required: true,
          message: '请选择单价',
          trigger: 'blur',
        },
        brandName: {
          required: true,
          message: '请选择品牌',
          trigger: 'blur',
        },
        priceType: {
          required: true,
          message: '请选择费用类型',
          trigger: 'blur',
        },
        startDate: {
          required: true,
          message: '请选择开始时间',
          trigger: 'blur',
        },
        endDate: {
          required: true,
          message: '请选择结束时间',
          trigger: 'blur',
        },
        customerName: {
          required: true,
          message: '请选择委托商',
          trigger: 'blur',
        },
      },
      dialogVisible: false,
      dialogImageUrl: '',
      priceTypeOption1: [],
      priceTypeOption2: [],
    };
  },
  filters: {
    transportTypeFormat(value) {
      switch (value) {
        case 1:
          return '公路';
        case 2:
          return '水路';
      }
    },
  },
  methods: {
    handleInput(val) {
      // console.log(val);
      if (val == 1 || val == 3) {
        this.priceTypeOption = this.priceTypeOption1;
      } else if(val == 2) {
        this.priceTypeOption = this.priceTypeOption2;
      } else {
        this.priceTypeOption = [];
      }
    },
    async dialogOpen(title,row) {
      this.dialogTitle = title;
      if(title === '修改'){
        this.modifyData = { ...row };
        this.modifyData['brandName'] = row.brandName.split('/')
        this.modifyData['priceType'] = String(this.modifyData['priceType']);
      } else {
        this.priceTypeOption = [];
      }
      const resBrandList = await yearMonthPlanHighwayBrandList();
      this.priceTypeOption2 = resBrandList.data;
      const {status, message, data} = await paramCategoryPageList({
        value: '',
        status: '',
        rows: 9999,
        Page: 1,
        classaName: '',
        states: '',
        paramId: '658625de271048b78be6f1f569211d14',
      });
      this.priceTypeOption1 = data.records;

      if (title === '修改') {
        if (row.transportType == 1 || row.transportType == 3) {
          this.priceTypeOption = this.priceTypeOption1;
        } else {
          this.priceTypeOption = this.priceTypeOption2;
        }
      }
      const res = await getModelList();
      this.brandNameOption = res.data;
      let res1 = await customerInfoSelectList();
      this.consignorOption = res1.data.map(item => {
        return {
          customer_name: item.customer_name,
          id: item.id,
        };
      });
      this.addDialogVisible = true
    },
    // 新增/修改确认
    addClick() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          this.loading = true
          let res
          if(this.dialogTitle === '新增'){
             res = await planConsignorAdd({
              transportType: this.modifyData.transportType,
              customerName: this.modifyData.customerName.customer_name,
              customerId: this.modifyData.customerName.id,
              startAddressName: this.modifyData.startAddressName,
              endAddressName: this.modifyData.endAddressName,
              brandName: this.modifyData.brandName.map(item=>item).join('/'),
              priceType: this.modifyData.priceType,
              price: this.modifyData.price,
              startDate: this.modifyData.startDate,
              endDate: this.modifyData.endDate,
              remake: this.modifyData.remake,
            })
          }else {
            res = await planConsignorUpdate({
              id: this.modifyData.id,
              transportType: this.modifyData.transportType,
              customerName: this.modifyData.customerName.customer_name,
              customerId: this.modifyData.customerName.id,
              startAddressName: this.modifyData.startAddressName,
              endAddressName: this.modifyData.endAddressName,
              brandName: this.modifyData.brandName.map(item=>item).join('/'),
              priceType: this.modifyData.priceType,
              price: this.modifyData.price,
              startDate: this.modifyData.startDate,
              endDate: this.modifyData.endDate,
              remake: this.modifyData.remake
            })
          }
          this.loading = false
          if (res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          this.$emit('searchBtn');
          this.addDialogVisible = false;
        }
      });
    },
    dialogClose() {
      this.modifyData = {
        transportType: '', //运输方式
        customerName: '', // 委托商
        startDate: '', // 有效期始
        endDate: '', // 结束时间
        startAddressName: '', // 起始地
        endAddressName: '', // 目的地
        brandName: '', // 品牌
        priceType: '',
        price: '',
        remake: ''
      };
      this.$refs.ruleForm.resetFields();
      this.addDialogVisible = false
    },
    // 判断时间大小
    getMax(date1, date2) {
      const oDate1 = new Date(date1);
      const oDate2 = new Date(date2);
      if (oDate1.getTime() > oDate2.getTime()) {
        console.log('第一个大');
        return true;
      } else {
        console.log('第二个大');
        return false;
      }
    },
    // 结束时间判断
    timeChange(value) {
      if (this.getMax(this.modifyData.startTime, value)) {
        this.$message.warning('结束时间不能小于起始时间');
        this.modifyData.endTime = '';
      }
    },
    // 起始时间判断
    validityTimeChange(value) {
      if (this.modifyData.endTime && this.getMax(value, this.modifyData.endTime)) {
        this.$message.warning('起始时间不能大于结束时间');
        this.modifyData.startTime = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.list-add {
  .el-dialog__wrapper {
    top: -52px;
  }

  ::v-deep .el-table__header .has-gutter tr .el-table-column--selection .cell .el-checkbox::after {
    color: #606266;
    content: '全选';
    font-size: 12px;
    margin-left: 2px;
  }

  ::v-deep .add {
    .el-form-item__label {
      font-weight: 700;
    }

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    width: 100%;
    padding: 10px 0 20px 20px;

    .baseInfo {
      display: flex;
      flex-direction: column;

      &Content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 23px 0 23px;
        font-size: 14px;

        .el-form-item {
          // margin-bottom: 15px;
          margin: 0;

          .el-form-item__error {
            top: 92%;
          }
        }

        .basicsStyle {
          .el-form-item {
            // margin-top: 3px;
            // margin-bottom: 5px;
            .el-input {
              width: 100%;
            }

            .el-select {
              width: 100%;
            }
          }

          .el-form-item__error {
            top: 96%;
          }

          // .el-input__inner {
          //   height: 24px;
          //   line-height: 24px;
          // }
          // .prepareType {
          //   .el-form-item__content {
          //     // line-height: 24px;
          //   }
          // }

          .el-icon-error {
            &:hover {
              color: #00cacc;
            }
          }
        }
      }
    }

    .el-table td,
    .el-table th {
      padding: 0;
    }

    .cell {
      font-size: 13px;
      padding: 0;
      font-weight: 900;
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 13px;
      margin-top: 20px;

      button {
        margin: 0 15px;
      }
    }
  }

  .el-pagination {
    margin-top: 10px;
    text-align: center;
  }
}

::v-deep {
  .el-table th.require > div::before {
    content: '*';
    color: red;
  }

  .el-input.is-disabled .el-input__inner {
    background-color: #fff;
    cursor: pointer;
  }

  .el-table__body tr.current-row > td {
    background-color: #409eff;
    color: #fff !important;
  }

  .cell .el-form-item {
    padding: 0 2px;
  }

  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
    text-align: center;
  }

  .el-dialog__headerbtn {
    top: 0px;
    height: 42px;
    line-height: 42px;
    right: 10px;
    font-size: 20px;

    .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }
  }

  .el-dialog__title {
    color: #fff;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
  }

  .el-dialog__body {
    padding: 20px !important;
    max-height: 60vh;
    overflow-y: auto;
  }

  .el-pagination {
    text-align: left !important;
  }

  .el-dialog__footer {
    text-align: right !important;
  }

  .el-form-item__content {
    line-height: 40px;
  }

  .cell .el-radio {
    margin-right: 0px;
    float: left;
    left: 10px;
  }

  .el-radio:last-child {
    margin-top: 3px;
  }
}

.list-add .add::v-deep {
  .cell p {
    display: inline-block;
    font-size: 13px;
    width: 100%;
    padding: 0 42px 0 5px;
    text-align: left;
  }
}

.item-span {
  font-size: 13px;
}

.set-up {
  color: #3187ff;
  position: absolute;
  // width: 26px !important;
  padding-right: 10px;
  height: 24px;
  line-height: 24px;
  right: 10px;
  top: calc(50% - 12px);
  text-decoration: underline;
  cursor: pointer;
}

.navBtn {
  display: inline-block;
  width: calc(100% - 690px);
  text-align: right;
  margin-bottom: 10px;
}

.navContainer {
  display: inline-block;
  width: 230px;
  text-align: center;

  p {
    display: inline-block;
    width: 70px;
  }
}
</style>
